"use strict";
/*
 * Created on 7. 10. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractEntityFilter_1 = require("../../core/model/overview/AbstractEntityFilter");
/**
 * Filter for Window list/overview page.
 * @author Radek Beran
 */


var WindowOverviewFilter =
/*#__PURE__*/
function (_AbstractEntityFilter) {
  _inherits(WindowOverviewFilter, _AbstractEntityFilter);

  function WindowOverviewFilter(ids, filter, promotionIds, promotionWeekType, select) {
    var _this;

    var simulationsOnly = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var storeSpecifications = arguments.length > 6 ? arguments[6] : undefined;
    var windowTypeIds = arguments.length > 7 ? arguments[7] : undefined;
    var promotionTypeIds = arguments.length > 8 ? arguments[8] : undefined;
    var years = arguments.length > 9 ? arguments[9] : undefined;
    var weeks = arguments.length > 10 ? arguments[10] : undefined;
    var windowWFState = arguments.length > 11 ? arguments[11] : undefined;
    var promotionWFState = arguments.length > 12 ? arguments[12] : undefined;
    var themeId = arguments.length > 13 ? arguments[13] : undefined;
    var promotionId = arguments.length > 14 ? arguments[14] : undefined;

    _classCallCheck(this, WindowOverviewFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowOverviewFilter).call(this));
    _this.ids = ids;
    _this.filter = filter;
    _this.promotionIds = promotionIds;
    _this.promotionWeekType = promotionWeekType;
    _this.select = select;
    _this.simulationsOnly = simulationsOnly;
    _this.storeSpecifications = storeSpecifications;
    _this.windowTypeIds = windowTypeIds;
    _this.promotionTypeIds = promotionTypeIds;
    _this.years = years;
    _this.weeks = weeks;
    _this.windowWFState = windowWFState;
    _this.promotionWFState = promotionWFState;
    _this.themeId = themeId;
    _this.promotionId = promotionId;
    return _this;
  }

  return WindowOverviewFilter;
}(AbstractEntityFilter_1.AbstractEntityFilter);

exports.WindowOverviewFilter = WindowOverviewFilter;
WindowOverviewFilter.EMPTY = new WindowOverviewFilter();